// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-students .select-kids{padding:0}`, "",{"version":3,"sources":["webpack://./src/modals/SelectStaff/style.scss"],"names":[],"mappings":"AAEE,8BACE,SAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
